import type { DraggableAttributes, useDraggable } from "@dnd-kit/core";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React, { CSSProperties, ReactNode, useContext, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TableContext from "../context/TableContext";
import actionIcon from "../img/action-icon.svg";

type Draggable = ReturnType<typeof useDraggable>;
type DraggableListeners = Draggable["listeners"];
export interface TableRowProps {
  one?: ReactNode;
  oneObj?: any;
  two?: ReactNode;
  twoObj?: any;
  three?: ReactNode;
  threeObj?: any;
  four?: ReactNode;
  five?: ReactNode;
  six?: ReactNode;
  seven?: ReactNode;
  eight?: ReactNode;
  nine?: ReactNode;
  ten?: ReactNode;
  eleven?: ReactNode;
  twelve?: ReactNode;
  loading?: true | false;
  onRowClick?: (params?: any) => void;
  action?: ReactNode;
  attributes?: DraggableAttributes;
  listeners?: DraggableListeners;
  draggable?: boolean;
  // onEdit?: any
  // dontShowEdit?: any
  // dontShowAction?: any
  rowNo?: any;
  // editText?: any
  // deleteText?: any
  // downloadText?: any
  // onDelete?: any
  // onDownload?: any
  className?: string;
  // imgActionOne?: any
  // imgActionTwo?: any
  // imgActionThree?: any
  // imgActionFour?: any
  // onClickActionOne?: any
  // onClickActionTwo?: any
  // onClickActionThree?: any
  // onClickActionFour?: any
  // actionDropAuto?: any
  styles?: CSSProperties;
  ManualAddActions?: any;
  ManualActionBox?: any;
  manualActionIcon?: any;
  draggableIcon?: React.ReactNode;
  item?: any;
  rowRef?: React.Ref<HTMLTableRowElement>;
}

const RazorTableRow: React.FC<TableRowProps> = ({
  one,
  oneObj,
  two,
  twoObj,
  three,
  threeObj,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  eleven,
  twelve,
  loading,
  item,
  draggable,
  onRowClick,
  // action,
  // onEdit,
  // dontShowEdit,
  // dontShowAction,
  rowNo,
  styles,
  // editText,
  // deleteText,
  // downloadText,
  // onDelete,
  // onDownload,
  // imgActionOne,
  // imgActionTwo,
  // imgActionThree,
  // imgActionFour,
  // onClickActionOne,
  // onClickActionTwo,
  // onClickActionThree,
  // onClickActionFour,
  // actionDropAuto,
  className,
  draggableIcon,
  ManualAddActions,
  ManualActionBox,
  manualActionIcon,
}) => {
  const [showDropAction, setShowDropAction] = useState(false);
  const tableCtx = useContext(TableContext);

  function TableData(props: any) {
    return (
      <td className="table-data table-data-action ">
        {props.content} {props.children}
      </td>
    );
  }

  function TableDataData(props: any) {
    return (
      <div className="">
        {props.content} {props.children}
      </div>
    );
  }

  const actionComponent = ManualAddActions ? <ManualAddActions /> : "";
  const actionComponentBox = ManualActionBox ? <ManualActionBox /> : "";

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item?.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  // const isDraggingRef = useRef(false);
  // const value
  // const handlePointerDown = (e: React.PointerEvent) => {
  //   isDraggingRef.current = false;
  //   listeners && listeners.onPointerDown?.(e);
  // };
  // const handlePointerMove = () => {
  //   isDraggingRef.current = true;
  // };
  // const handleClick = () => {
  //   if (!isDraggingRef.current && onRowClick) {
  //     onRowClick(item);
  //   }
  // };

  return (
    <>
      {draggable ? (
        <tr
          ref={setNodeRef}
          style={{
            zIndex:
              showDropAction && rowNo === tableCtx?.dropDownActive ? "3" : "1",
            ...style,
            ...styles,
          }}
          className={`table-row ${className}`}
        >
          <td
            className="table-data"
            {...listeners}
            {...attributes}
            style={{ cursor: "grab", width: "5rem", paddingRight: "2rem" }}
          >
            {loading ? (
              <Skeleton width={20} height={17} />
            ) : (
              <span>{draggableIcon ? draggableIcon : "☰"}</span>
            )}
          </td>
          {one ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{one}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {oneObj ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <div className="img-text">
                  {" "}
                  <Skeleton
                    width={30}
                    height={30}
                    circle
                    style={{ marginRight: "1rem" }}
                  />{" "}
                  <Skeleton width={150} height={17} />
                </div>
              ) : (
                <div className="img-text">
                  <figure className="img-box">
                    <img src={oneObj?.img} alt="" className="img" />
                  </figure>
                  <span>{oneObj?.label}</span>
                </div>
              )}
            </td>
          ) : (
            ""
          )}
          {two ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{two}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {twoObj ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <div className="img-text">
                  {" "}
                  <Skeleton
                    width={30}
                    height={30}
                    circle
                    style={{ marginRight: "1rem" }}
                  />{" "}
                  <Skeleton width={`70%`} height={17} />
                </div>
              ) : (
                <div className="img-text">
                  <figure className="img-box">
                    <img src={twoObj?.img} alt="" className="img" />
                  </figure>
                  <span>{twoObj?.label}</span>
                </div>
              )}
            </td>
          ) : (
            ""
          )}
          {three ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{three}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {threeObj ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <div className="img-text">
                  {" "}
                  <Skeleton
                    width={30}
                    height={30}
                    circle
                    style={{ marginRight: "1rem" }}
                  />{" "}
                  <Skeleton width={`70%`} height={17} />
                </div>
              ) : (
                <div className="img-text">
                  <figure className="img-box">
                    <img src={threeObj?.img} alt="" className="img" />
                  </figure>
                  <span>{threeObj?.label}</span>
                </div>
              )}
            </td>
          ) : (
            ""
          )}
          {four ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{four}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {five ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{five}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {six ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{six}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {seven ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{seven}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {eight ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{eight}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {nine ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{nine}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {ten ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{ten}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {eleven ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{eleven}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {twelve ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{twelve}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {ManualAddActions ? (
            <TableData content={actionComponent}>
              {" "}
              <div className="action-box">
                {ManualActionBox && (
                  <>
                    {loading ? (
                      <Skeleton circle width={30} height={30} />
                    ) : (
                      <div className="action-wrap">
                        <figure
                          onClick={() => {
                            // setIndexNo();
                            tableCtx?.setShowDropActive(rowNo);
                            tableCtx?.dropDownActive === rowNo
                              ? setShowDropAction(!showDropAction)
                              : setShowDropAction(true);
                          }}
                          className="img-box"
                        >
                          <img
                            src={manualActionIcon || actionIcon}
                            alt=""
                            className="img"
                          />
                        </figure>
                        {/* action drop start */}
                        {/* <div
                      className={`drop-box ${
                        showDropAction &&
                        tableCtx?.dropDownActive === rowNo &&
                        "drop-box-show"
                      }`}
                    > */}
                        <TableDataData content={actionComponentBox} />
                        {/* </div> */}
                        {/* action drop end */}
                      </div>
                    )}
                  </>
                )}
              </div>
            </TableData>
          ) : (
            ""
          )}
        </tr>
      ) : (
        <tr
          style={{
            zIndex:
              showDropAction && rowNo === tableCtx?.dropDownActive ? "3" : "1",
          }}
          className={`table-row ${className}`}
        >
          {one ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{one}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {oneObj ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <div className="img-text">
                  {" "}
                  <Skeleton
                    width={30}
                    height={30}
                    circle
                    style={{ marginRight: "1rem" }}
                  />{" "}
                  <Skeleton width={150} height={17} />
                </div>
              ) : (
                <div className="img-text">
                  <figure className="img-box">
                    <img src={oneObj?.img} alt="" className="img" />
                  </figure>
                  <span>{oneObj?.label}</span>
                </div>
              )}
            </td>
          ) : (
            ""
          )}
          {two ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{two}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {twoObj ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <div className="img-text">
                  {" "}
                  <Skeleton
                    width={30}
                    height={30}
                    circle
                    style={{ marginRight: "1rem" }}
                  />{" "}
                  <Skeleton width={`70%`} height={17} />
                </div>
              ) : (
                <div className="img-text">
                  <figure className="img-box">
                    <img src={twoObj?.img} alt="" className="img" />
                  </figure>
                  <span>{twoObj?.label}</span>
                </div>
              )}
            </td>
          ) : (
            ""
          )}
          {three ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{three}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {threeObj ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <div className="img-text">
                  {" "}
                  <Skeleton
                    width={30}
                    height={30}
                    circle
                    style={{ marginRight: "1rem" }}
                  />{" "}
                  <Skeleton width={`70%`} height={17} />
                </div>
              ) : (
                <div className="img-text">
                  <figure className="img-box">
                    <img src={threeObj?.img} alt="" className="img" />
                  </figure>
                  <span>{threeObj?.label}</span>
                </div>
              )}
            </td>
          ) : (
            ""
          )}
          {four ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{four}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {five ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{five}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {six ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{six}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {seven ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{seven}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {eight ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{eight}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {nine ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{nine}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {ten ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{ten}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {eleven ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{eleven}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {twelve ? (
            <td
              onClick={() => {
                onRowClick?.();
                tableCtx?.setShowDropActive("");
              }}
              className="table-data"
            >
              {loading ? (
                <Skeleton width={`70%`} height={17} />
              ) : (
                <span>{twelve}</span>
              )}
            </td>
          ) : (
            ""
          )}
          {ManualAddActions ? (
            <TableData content={actionComponent}>
              {" "}
              <div className="action-box">
                {ManualActionBox && (
                  <>
                    {loading ? (
                      <Skeleton circle width={30} height={30} />
                    ) : (
                      <div className="action-wrap">
                        <figure
                          onClick={() => {
                            // setIndexNo();
                            tableCtx?.setShowDropActive(rowNo);
                            tableCtx?.dropDownActive === rowNo
                              ? setShowDropAction(!showDropAction)
                              : setShowDropAction(true);
                          }}
                          className="img-box"
                        >
                          <img
                            src={manualActionIcon || actionIcon}
                            alt=""
                            className="img"
                          />
                        </figure>
                        {/* action drop start */}
                        {/* <div
                      className={`drop-box ${
                        showDropAction &&
                        tableCtx?.dropDownActive === rowNo &&
                        "drop-box-show"
                      }`}
                    > */}
                        <TableDataData content={actionComponentBox} />
                        {/* </div> */}
                        {/* action drop end */}
                      </div>
                    )}
                  </>
                )}
              </div>
            </TableData>
          ) : (
            ""
          )}
        </tr>
      )}
    </>
  );
};

export default RazorTableRow;
